module.exports = [
  "Häuser",
  "Bungalow",
  "Burg/Schloss",
  "Doppelhaushälfte",
  "Zweifamilienhaus",
  "Einfamilienhaus mit Einliegerwohnung",
  "Einfamilienhaus",
  "Bauernhaus",
  "Mehrfamilienhaus",
  "Reihenhaus",
  "Reiheneckhaus",
  "Reihenendhaus",
  "Reihenmittelhaus",
  "sonstige Häuser",
  "Villa",
  "besondere Immobilie",
  "Haus",
  "Ein/Mehrfamilienhaus",
  "Typenhäuser",
  "Blockhaus",
  "Doppelhaus",
  "EinfamilienhausMitEinliegerwohnung",
  "Fachwerkhaus",
  "Holzhaus",
  "Landhaus",
  "Mehrfamilienhaus",
  "Stadtvilla",
  "Finca",
  "Zweifamilienhaus",
];



// WEBPACK FOOTER //
// ./src/data/house.js